export default {"src":"/_next/static/media/Estelle.fb5d9f0d.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};